import React, { useState } from 'react';
import propTypes from 'prop-types';
import { usePoseWithBulma } from 'src/ui/hooks';
import { Button, ModalCardHeader, ModalCardTitle, ModalCard, ModalBackground, Modal, Content, ModalCardBody } from 'src/ui/mui-ui-kit';;
import {
  FadeInDiv,
  AnimatedCard,
  UiInputAdapter,
  InnerLoader,
  UiToastAdapter,
} from 'src/ui';
import { Form, Field } from 'react-final-form';
import { composeValidators, required, email } from 'src/ui/validations';
import { toast } from 'react-toastify';
import { resetPassword } from '../services';

export function ResetPasswordModal({ isActive, currentEmail = '', onCancel }) {
  const [loading, setLoading] = useState(false);
  const [currentPose, isModalVisible, onPoseComplete] = usePoseWithBulma(
    isActive
  );

  async function onSubmit({ email }) {
    setLoading(true);
    await resetPassword(email);
    setLoading(false);

    toast(
      UiToastAdapter(
        'A link has been sent to the specified e-mail address.',
        'success'
      )
    );
    onCancel();
  }

  return (
    <Modal isActive={isModalVisible}>
      <ModalBackground
        tag={FadeInDiv}
        pose={currentPose}
        onPoseComplete={onPoseComplete}
      />
      <ModalCard tag={AnimatedCard} pose={currentPose}>
        <InnerLoader visible={loading} />
        <ModalCardHeader>
          <ModalCardTitle tag="h6" className="has-text-weight-semibold">
            Reset Password
          </ModalCardTitle>
        </ModalCardHeader>
        <Form
          onSubmit={onSubmit}
          subscription={{
            hasValidationErrors: true,
            submitting: true,
          }}
          initialValues={{
            email: currentEmail,
          }}
          render={({ handleSubmit, hasValidationErrors, submitting }) => (
            <ModalCardBody tag="form" onSubmit={handleSubmit} noValidate>
              <Content>
                <p className="has-text-grey-medium-dark">
                  A link will be sent to your e-mail address allowing you to
                  choose a new password.
                </p>
              </Content>
              <Field
                component={UiInputAdapter}
                id="resetEmail"
                name="email"
                type="email"
                validate={composeValidators('E-mail Address', required, email)}
                label="E-mail Address"
                required
                hideAsterisk
              />
              <div className="buttons is-centered">
                <Button hasTextColor="info" onClick={onCancel}>
                  Cancel
                </Button>
                <Button
                  isColor="gradient-bright"
                  type="submit"
                  disabled={submitting || hasValidationErrors}
                >
                  Reset Password
                </Button>
              </div>
            </ModalCardBody>
          )}
        />
      </ModalCard>
    </Modal>
  );
}



// eslint-disable-next-line react/require-default-props
ResetPasswordModal.propTypes = {
  currentEmail: propTypes.string,
  isActive: propTypes.bool.isRequired,
  onCancel: propTypes.func.isRequired,
};
